export const hostProviderKey = 'hostProvider';
